// CELL-BIO9 — save system. Three localStorage slots, autosave on every node
// transition. The player is never prompted to save manually.

import type { StateSnapshot } from "./gameState";

export type SlotNumber = 1 | 2 | 3;

const SLOT_PREFIX = "cellbio9_slot_";
const SAVE_VERSION = 1;

interface SaveBlob {
  version: number;
  savedAt: string;
  state: StateSnapshot;
}

let activeSlot: SlotNumber = 1;

export function setActiveSlot(slot: SlotNumber): void {
  activeSlot = slot;
}

export function getActiveSlot(): SlotNumber {
  return activeSlot;
}

function key(slot: SlotNumber): string {
  return `${SLOT_PREFIX}${slot}`;
}

/** Autosave the current snapshot into the active slot. Called on every node transition. */
export function autosave(state: StateSnapshot): void {
  const blob: SaveBlob = {
    version: SAVE_VERSION,
    savedAt: new Date().toISOString(),
    state,
  };
  try {
    localStorage.setItem(key(activeSlot), JSON.stringify(blob));
  } catch {
    // Storage may be unavailable (private mode / quota). The game must not break.
  }
}

export function loadSlot(slot: SlotNumber): StateSnapshot | null {
  try {
    const raw = localStorage.getItem(key(slot));
    if (!raw) return null;
    const blob = JSON.parse(raw) as SaveBlob;
    if (blob.version !== SAVE_VERSION || !blob.state || !blob.state.currentNode) {
      return null;
    }
    return blob.state;
  } catch {
    return null;
  }
}

export function clearSlot(slot: SlotNumber): void {
  try {
    localStorage.removeItem(key(slot));
  } catch {
    // ignore
  }
}